// @flow
import { createStore, applyMiddleware  } from 'redux';
import thunk from 'redux-thunk';
import Plantilla6App from './reducers';


export default createStore(
  Plantilla6App,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line
  applyMiddleware(thunk),
);



// WEBPACK FOOTER //
// ./src/store.js